var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.742,
    height: 12.475,
    viewBox: "0 0 17.742 12.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M18.421,6.452a2.229,2.229,0,0,0-1.569-1.579A52.68,52.68,0,0,0,9.921,4.5a52.681,52.681,0,0,0-6.932.373A2.229,2.229,0,0,0,1.421,6.452a23.387,23.387,0,0,0-.371,4.3,23.387,23.387,0,0,0,.371,4.3A2.2,2.2,0,0,0,2.989,16.6a52.681,52.681,0,0,0,6.932.373,52.68,52.68,0,0,0,6.932-.373,2.2,2.2,0,0,0,1.569-1.554,23.387,23.387,0,0,0,.371-4.3,23.387,23.387,0,0,0-.371-4.3ZM8.106,13.388V8.112l4.637,2.638L8.106,13.388Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8018c76b13149fd3abc4a4e7733779d3.svg";
export { ForwardRef as ReactComponent };